// @flow
import React from 'react'
import { Link } from 'react-router-dom'

export const EmailSent = (): any => {
  return (
    <div className='pw-reset-password'>
      <div className='pw-reset-password__header'>
        <i className='icon icon--logo' />
        <h3>A recovery email has been sent to your address.</h3>
      </div>
      <Link to='/' className='pw-reset-password__login'>Return to Login Page</Link>
    </div>
  )
}

EmailSent.displayName = 'EmailSent'

export default EmailSent
